import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';
import { AtsTool } from './types';

const cancelableFetchAtsTools = async (): Promise<AtsTool[]> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<AtsTool[]>(`kombo/ats-tools`);

export const CancelableAtsToolGateway = {
    cancelableFetchAtsTools,
};
